import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // { type: 'success' | 'error', message: string }
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus(null);

    try {
      const response = await fetch('https://api.myapoti.com/users/newsletter/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Subscription failed');
      }

      setStatus({ type: 'success', message: 'Thank you! You’ll be notified.' });
      setEmail('');
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="apoti-footer">
      <div className="apoti-footer-container">
        <div className="apoti-footer-top">
          <div className="apoti-brand">
            <h2>MyApoti</h2>
            <p>Bringing verified pharmacies and reliable drug access to your fingertips.</p>
          </div>

          <div className="apoti-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/HowItWorks">How It Works</a></li>
              <li><a href="/AmbassadorPromoSection">Ambassador Program</a></li>
            </ul>
          </div>

          <div className="apoti-support">
            <h4>Support</h4>
            <ul>
              <li><a href="/">Help Center</a></li>
              <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="apoti-newsletter">
            <h4>Stay Informed</h4>
            <p>Subscribe to receive updates when we launch.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
              <button type="submit" disabled={isLoading}>
                {isLoading ? 'Submitting...' : 'Notify Me'}
              </button>
            </form>
            {status && (
              <p className={status.type === 'success' ? 'success-message' : 'error-message'}>
                {status.message}
              </p>
            )}
          </div>
        </div>

        <div className="apoti-footer-bottom">
          <p>&copy; {new Date().getFullYear()} MyApoti. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
